import greycat from './__gen/greycat_no_fs';
import greycatModule from '../greycat.wasm';
// Since webpack will change the name and potentially the path of the
// `.wasm` file, we have to provide a `locateFile()` hook to redirect
// to the appropriate URL.
// More details: https://kripken.github.io/emscripten-site/docs/api_reference/module.html
export default greycat({
  locateFile: function (path) {
    if (path.substr(path.length - '.wasm'.length, path.length) === '.wasm') {
      return greycatModule;
    }
    return path;
  },
});
